import { loadState, saveState } from "shared/localstorage_helpers"
import { initialState } from "shared/components/connection_card/reducers/user"
import { storageIdentifier } from "shared/components/connection_card/utils.js"
import fetchSessionContext from "shared/lib/session_context"

export default function SignedOutConnectButton() {
  const connectButton = document.querySelector(".connect-button")
  // connection_id/session_id, not appletSlug/sessionId: the helper serialises snake_case,
  // so both were undefined and the key never matched the signed-in side's.
  const { url, connection_id: connectionId, session_id: sessionId } = JSON.parse(connectButton.dataset.connect)

  // Fetched, not rendered: the applet page is CDN-cached for anonymous visitors.
  // Bounded because a stalled fetch plus `{ once: true }` would eat the click and
  // never navigate — losing attribution beats losing the navigation.
  const sessionIdPromise = sessionId
    ? Promise.resolve(sessionId)
    : Promise.race([
        fetchSessionContext({ connect: true }).then(({ connect_flow_session_id }) => connect_flow_session_id),
        new Promise(resolve => setTimeout(resolve, 500)),
      ]).catch(() => undefined)

  connectButton.addEventListener(
    "click",
    async () => {
      const localStorageId = storageIdentifier(connectionId, await sessionIdPromise)

      const persistedState = loadState(localStorageId) || {
        user: initialState,
      }
      persistedState.user.authRequestedAt = new Date().toISOString()

      // persistedState, not initialState — saving the latter dropped the
      // authRequestedAt set on the line above, so the handoff never carried it.
      saveState(persistedState, localStorageId)

      window.location.assign(url)
    },
    { once: true },
  )
}
